"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardTag_vue_1 = require("@/client/components/card/CardTag.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardTags',
    props: {
        tags: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardTag: CardTag_vue_1.default,
    },
});
